import React from "react";
import PropTypes from "kf-proptypes/widgets";

import { USER_KIND } from "base/constants";

import {
  StatusChip,
  STATUS_CHIP_COLOR,
  STATUS_CHIP_TYPE,
  CHIP_SIZES
} from "../chip/index.jsx";
import { UserIcon, AVATAR_SIZE } from "../usericon/index.jsx";
import { OverflowText } from "../overflowtext/index.jsx";
import {
  ICON_SIZE,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./usermenuitem.css";

const USER_BADGE = {
  ExternalUser: () => (
    <StatusChip
      color={STATUS_CHIP_COLOR.GRAY}
      type={STATUS_CHIP_TYPE.OUTLINE}
      size={CHIP_SIZES.TINY}
    >
      External
    </StatusChip>
  ),
  ExternalGroup: () => (
    <StatusChip
      color={STATUS_CHIP_COLOR.GRAY}
      type={STATUS_CHIP_TYPE.OUTLINE}
      size={CHIP_SIZES.TINY}
    >
      External
    </StatusChip>
  ),
  User: () => null,
  Group: () => null,
  Role: () => null,
  AppRole: () => null,
  ServiceAccount: () => (
    <StatusChip
      color={STATUS_CHIP_COLOR.GRAY}
      type={STATUS_CHIP_TYPE.OUTLINE}
      size={CHIP_SIZES.TINY}
    >
      SA
    </StatusChip>
  )
};

/**
 * Display user menu seach item renderer
 */

export function UserMenuItem(props) {
  const {
    userId,
    name,
    email,
    kind = USER_KIND.USER,
    chipRenderer = USER_BADGE[kind],
    iconName = "",
    accountId
  } = props;

  return (
    <div className={styles.item}>
      {iconName ? (
        <div className={styles.customIconContainer}>
          <KfIcon icon={iconName} size={ICON_SIZE.SIZE_32} />
        </div>
      ) : (
        <UserIcon
          className={styles.itemProfileImage}
          userId={userId}
          name={name}
          size={AVATAR_SIZE.SIZE36}
          accountId={accountId}
        />
      )}
      <div style={{ overflow: "hidden" }}>
        <div className={`base ${styles.nameWithBadge}`}>
          <OverflowText>{name}</OverflowText> {chipRenderer()}
        </div>
        {email && kind !== USER_KIND.SERVICE_ACCOUNT && (
          <div dir="auto" className={`ellipsis tiny ${styles.mail}`}>
            {email}
          </div>
        )}
      </div>
    </div>
  );
}

UserMenuItem.propTypes = {
  /**
   * gets the userId
   */
  userId: PropTypes.string.isRequired,
  /**
   * name of the user, if user does not have profile pic then user name first letter will be user icon
   */
  name: PropTypes.string,
  /**
   * email of the user
   */
  email: PropTypes.string,
  /**
   * To show user or group or service account badge
   */
  kind: PropTypes.oneOf(Object.values(USER_KIND)),
  /**
   * apart from service account, external chip other chip also can be sent as prop
   */
  chipRenderer: PropTypes.func,
  /** iconName is to show a particular icon */
  iconName: PropTypes.string,
  /**
   * To load sandbox user icon
   */
  accountId: PropTypes.string
};
